import { useEffect, useRef, useCallback } from 'react';
import { useStore } from '../store/useStore';
import SoundManager from '../services/SoundManager';

/**
 * Хук для управления звуковыми эффектами
 * Использует глобальный SoundManager для быстрого воспроизведения
 * @param soundPath - путь к звуковому файлу относительно /assets/sounds/
 * @returns функция для проигрывания звука
 */
export const useSound = (soundPath: string) => {
  const soundEnabled = useStore(state => state.soundEnabled);
  const prevSoundEnabled = useRef<boolean | undefined>(undefined);

  // Синхронизируем состояние звука с SoundManager ТОЛЬКО при изменении
  useEffect(() => {
    // Устанавливаем только если значение реально изменилось
    if (prevSoundEnabled.current !== soundEnabled) {
      prevSoundEnabled.current = soundEnabled;
      SoundManager.setSoundEnabled(soundEnabled);
    }
  }, [soundEnabled]);

  // Мемоизируем функцию play чтобы избежать лишних ререндеров
  const play = useCallback(() => {
    SoundManager.play(soundPath);
  }, [soundPath]);

  return play;
};
